import { DynamicFieldAttributes } from '@frontend/design-system';

const INDIVIDUAL_FORM_LINK_DYNAMIC_FIELD = '{{FORMS_LINK}}';
const GROUP_FORM_LINK_DYNAMIC_FIELD = '{{FORMS_LINKS}}';

export const getWeaveFormDynamicField = (dynamicFields?: DynamicFieldAttributes[]) =>
  dynamicFields?.find(
    (df) => df.symbol === INDIVIDUAL_FORM_LINK_DYNAMIC_FIELD || df.symbol === GROUP_FORM_LINK_DYNAMIC_FIELD
  )?.symbol ?? INDIVIDUAL_FORM_LINK_DYNAMIC_FIELD;
